import { CardModel, PileModel } from "../../interface/game";
import { PileClickPolicy } from "./pile-click-policy";


export function pileConditionalClickPolicy(
    defaultPolicy: PileClickPolicy,
    policyByNumber: {
        [key: number]: PileClickPolicy
    }
): PileClickPolicy {
    return (pileId: string, piles: {[key: string]: PileModel}, cards: {[key: string]: CardModel}) => {
        const pile = piles[pileId];
        const policy = policyByNumber[pile.cards.length] ?? defaultPolicy;
        console.log('Conditional', policy);
        return policy(pileId, piles, cards);
    }
}